<script setup lang="ts">
import { LabelWithIconAndLink } from "./LabelWithIconAndLink.props"
import { iconsMap } from "./LabelWithIconAndLink.iconMapping"

const props = defineProps<LabelWithIconAndLink>()
</script>

<template>
  <AppLink v-if="labelLink" :to="labelLink" class="flex items-center gap-2">
    <div v-if="labelIcon" class="iconWrapper bg-tiffany-10 rounded-full p-2">
      <UtilsIcon class="h-4 w-4" :name="iconsMap[labelIcon]" />
    </div>
    <span class="beaver-bold uppercase underline">{{ label }}</span>
  </AppLink>
  <span v-else class="flex items-center gap-2">
    <div v-if="labelIcon" class="iconWrapper bg-tiffany-10 rounded-full p-2">
      <UtilsIcon class="h-4 w-4" :name="iconsMap[labelIcon]" />
    </div>
    <span class="beaver-bold uppercase">{{ label }}</span>
  </span>
</template>
